import React, { useState, useEffect, useImperativeHandle, forwardRef } from 'react';
import { Modal } from 'antd';
import './submitJobConfirm.css';
import PropTypes from 'prop-types';

import asReviewWpaFormConfim from '../../public/img/std/asReviewWpaFormConfim.png'
import cancelImg from '../../public/img/newMain/cancel.png';

/**
 * 消息提示组件
 * props传参如下
 * 消息提示类型,样式 ['error','success','warning','info']
 *                              error:错误提示框，红色样式
 *                              success:成功提示框，绿色样式
 *                              warning:警告提示框，黄色样式
 *                              info:普通提示框，蓝色样式
 */
let SubmitJobConfirm = (props, ref) => {

    const [content, setContent] = useState("");
    const [isShow, setIsShow] = useState(false);
    useImperativeHandle(ref, () => {
        return {
            setContent,
            setIsShow,
        }
    });

    /**
     * 标题默认值处理
     */
    useEffect(() => {

    }, []);

    const save = () => {
        props.done(true);
    }

    const cancel = () => {
        props.done(false);
    }

    return (
        <Modal
            open={isShow}
            onCancel={null}
            closeIcon={null}
            footer={null}
            className='submitJobConfirm'
            width={693}
            centered
            closable={false}
        >
            <div className='contentBox'>
                <div>The Module Convener of your selected Programme will have access to all job applications and related communication for this job post.</div>
                <div>However, the &quot;IP Comment&quot; section in each job application is reserved for Industry Partner&apos;s private use, and will remain confidential to the Industry Partner.</div>
                <div>Confirm to Submit?</div>
                {/* {content} */}
            </div>
            <div className='butArea'>
                <div className='saveButton' onClick={save}><img src={asReviewWpaFormConfim} />Confirm</div>
                <div className='cancelButton' onClick={cancel}><img src={cancelImg} />Cancel</div>
            </div>

        </Modal>
    )

}

SubmitJobConfirm = forwardRef(SubmitJobConfirm);

SubmitJobConfirm.propTypes = {
    done: PropTypes.func.isRequired,
};

export default SubmitJobConfirm;